import { FileJobType } from './file-job.enums.js'

/** Maximum number of Files accepted by a single File Job request. */
export const FILE_JOB_MAX_FILES_PER_REQUEST = 100

/**
 * The job types a client may create through `POST /files/jobs`. A system-registered
 * type (`ZIP_INSPECTION`) is deliberately absent: it is created only by trusted
 * backend code, never from a request body.
 */
export const CLIENT_CREATABLE_FILE_JOB_TYPES = [FileJobType.ZIP] as const

/** The job types `GET /files/jobs?type=` lists and accepts. */
export const CLIENT_LISTABLE_FILE_JOB_TYPES = [FileJobType.ZIP] as const
